
export const register = async (data) => {
  try {
    const response = await fetch("/api/register", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });

    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.error || "Registration failed.");
    }
    return result; // Return result if successful
  } catch (error) {
    throw new Error(error.message);
  }
};

export const login = async (data) => {
  try {
    const response = await fetch("/api/login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });

    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.error || "Login failed.");
    }
    return result; // Return result if successful
  } catch (error) {
    throw new Error(error.message);
  }
};

export const sendChatbot = async (uid, input) => {
  try {
    const response = await fetch(`/route/chat`,
      {
        method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
        body: JSON.stringify({ message: input, userId: uid }),
      }
    );
    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.error);
    }
    return result.response; 
  } catch (error) {
    throw new Error(error.message);
  }
}

export const approveApplication = async(id, petName) =>{
  try {
    const response = await fetch(`/email/approve-application/${id}/${petName}`,
      {
        method:"POST",
        headers:{"Content-Type": "application/json"},
      }
    );
    const result = await response.json();
    if(!response.ok)
    {
      throw new Error (result.error||"approve application failed");
    }
    return result;
  } catch (error) {
    throw new Error(`Error approve application: ${error.message}`);
  }
}

export const finalApprove = async(id, petName) =>{
  try {
    const response = await fetch(`/email/final-approve-adoption/${id}/${petName}`,
      {
        method:"POST",
        headers:{"Content-Type": "application/json"},
      }
    );
    const result = await response.json();
    if(!response.ok)
    {
      throw new Error (result.error||"approve application failed");
    }
    return result;
  } catch (error) {
    throw new Error(`Error approve application: ${error.message}`);
  }
}

export const rejectApplication = async(id, petName, reason) =>{
  try {
    const response = await fetch(`/email/reject-application/${id}/${petName}`,
      {
        method:"POST",
        headers:{"Content-Type": "application/json"},
        body: JSON.stringify({ rejectionReason: reason }),
      }
    );
    const result = await response.json();
    if(!response.ok)
    {
      throw new Error (result.error||"approve application failed");
    }
    return result;
  } catch (error) {
    throw new Error(`Error approve application: ${error.message}`);
  }
}
